import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'acabim-admin-asset-type-classification',
  templateUrl: './asset-type-classification.component.html',
  styleUrls: ['./asset-type-classification.component.scss']
})
export class AssetTypeClassificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
